import { Link } from 'react-router-dom';
import styled from 'styled-components';

// export const Container = styled.a<{ isEditMode: boolean; isDeleteInclude: boolean }>`
export const Container = styled(Link)<{ isEditMode: boolean; isDeleteInclude: boolean }>`
	width: calc(100% + 40px);
	margin-left: -20px;
	padding: 12px 20px;
	padding-top: ${({ isEditMode }) => (isEditMode ? '12px' : 'calc(24px + 12px + 4px)')};
	position: relative;

	border-bottom: 1px solid ${({ theme }) => theme['warmgray-100']};

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	gap: ${({ isEditMode }) => (isEditMode ? '12px' : '10px')};

	text-decoration: none;

	background-color: ${({ isDeleteInclude, theme }) =>
		isDeleteInclude ? theme['orange-tertiary'] : 'white'};
`;

export const SelectIcon = styled.div`
	align-self: center;

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const TextContainer = styled.div`
	width: 100%;
	height: 100%;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 4px;
`;

export const TextRow = styled.div`
	display: flex;
	gap: 4px;
`;

export const FolderTextRow = styled(TextRow)`
	position: absolute;
	top: 12px;
	left: 18px;
	z-index: 20;
	/* background-color: red; */

	width: calc(100% - 36px);
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const Thumbnail = styled.img`
	width: 64px;
	height: 64px;

	object-fit: cover;
	align-self: flex-start;

	border-radius: 6px;
	flex-shrink: 0;
`;

export const FolderOptionIconWrapper = styled.div`
	svg {
		width: 24px;
		height: 24px;

		circle {
			stroke: ${({ theme }) => theme['warmgray-400']};
		}
		ellipse {
			stroke: ${({ theme }) => theme['warmgray-400']};
		}
	}
`;

export const RightContainer = styled.div`
	align-self: stretch;

	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-end;
	gap: 16px;
`;

export const PinWrapper = styled.div<{ isPinned: boolean }>`
	svg {
		width: 24px;
		height: 24px;
	}

	path {
		stroke: ${({ isPinned, theme }) =>
			isPinned ? theme['orange-primary'] : theme['warmgray-400']};
	}
`;
